import { ALBIS_ROLE_LABEL } from "./albisVoice";
import { guestLoginHref } from "./guestAcquisition";
import { PARENT_MAIL_LABEL } from "./scheduleLabels";

export const ERSTE_HAUSHALTE_SCENARIO = "erste_haushalte";

export const ERSTE_HAUSHALTE_ANSWERS = [
  "deadlines",
  "sync",
  "everyday",
  "parent",
  "other",
];

export const ERSTE_HAUSHALTE_DETAIL_MAX = 500;

export const ERSTE_HAUSHALTE_CTA_LABEL = "Mitmachen";

export const SCHOOL_DEMO_VARIANTS = [
  "deadline",
  "pack",
  "schedule",
  "rare_admin",
  "other",
];

export const JOB_OPTIONS = [
  { id: "deadlines", label: "Fristen und Termine (Mails, Flyer, nichts verpassen)" },
  { id: "sync", label: "Dass wir zuhause denselben Stand haben" },
  { id: "everyday", label: "Alltag rund ums Kind (Essen, Rausgehen, das Kleine)" },
  { id: "parent", label: "Die Last bei mir — nicht nur die Logistik" },
  { id: "other", label: "Anders" },
];

export const ERSTE_HAUSHALTE_HEADLINE = `Was muss ein ${ALBIS_ROLE_LABEL} euch zuerst abnehmen?`;

export const ERSTE_HAUSHALTE_LEAD =
  "Ziel: Mental Load runter, Kopf frei für die Familie. Albis ist ein kleines Projekt aus Zürich.";

export const ERSTE_HAUSHALTE_TRUST =
  "Eine Frage, kein Konto. Danach siehst du, was heute schon bereit ist.";

export const ERSTE_HAUSHALTE_QUESTION = `Wenn du an einen ${ALBIS_ROLE_LABEL} denkst — was muss der euch zuerst abnehmen?`;

export const ERSTE_HAUSHALTE_VISION = `Ich bin euer ${ALBIS_ROLE_LABEL}. Die Last aus dem Kopf — damit Zeit bei euch bleibt.`;

export const ERSTE_HAUSHALTE_READY_TEXT = `Bereit ist als Erstes: ${PARENT_MAIL_LABEL} weiterleiten oder Flyer fotografieren — Termine mache ich kalenderfertig, statt dass sie in der Flut bleiben.`;

export const ERSTE_HAUSHALTE_SETUP_HINT =
  "Mitmachen: anmelden, eine Mail weiterleiten oder ein Foto vom Flyer — und mir sagen, wo die Richtung falsch ist.";

const THANKS_BY_ANSWER = {
  deadlines: "Danke — genau da kann ich heute schon entlasten.",
  sync:
    "Danke — denselben Stand zuhause gehört dazu. Termine und Fristen seht ihr beide, sobald euer Partner dabei ist.",
  everyday:
    "Danke — Essen, Rausgehen, das Kleine gehört dazu. Heute fange ich bei den Fristen an.",
  parent: "Danke — ich soll auch dich entlasten, nicht nur die Logistik.",
  other: "Danke — genau dafür sind erste Haushalte da.",
};

/** @param {string | null | undefined} raw */
export function isErsteHaushalteScenario(raw) {
  return raw === ERSTE_HAUSHALTE_SCENARIO;
}

/**
 * @param {string | null | undefined} raw
 * @returns {"deadlines"|"sync"|"everyday"|"parent"|"other"}
 */
export function parseErsteHaushalteAnswer(raw) {
  if (raw && ERSTE_HAUSHALTE_ANSWERS.includes(raw)) return raw;
  return "deadlines";
}

/**
 * Compact school-demo variant for the guest card.
 * @param {string | null | undefined} raw
 * @returns {"deadline"|"pack"|"schedule"|"rare_admin"|"other"}
 */
export function parseSchoolDemoVariant(raw) {
  if (raw && SCHOOL_DEMO_VARIANTS.includes(raw)) return raw;
  return "deadline";
}

/** @param {string | null | undefined} answer */
export function demoVariantForAnswer(answer) {
  return parseErsteHaushalteAnswer(answer) === "sync" ? "schedule" : "deadline";
}

/** @param {string | null | undefined} raw */
export function normalizeErsteHaushalteDetail(raw) {
  const text = String(raw || "").trim().slice(0, ERSTE_HAUSHALTE_DETAIL_MAX);
  return text || null;
}

/**
 * Guest chat after the week-0 question.
 * @param {{ answer?: string | null }} [opts]
 */
export function ersteHaushalteChatPath({ answer = "deadlines" } = {}) {
  const job = parseErsteHaushalteAnswer(answer);
  const params = new URLSearchParams({
    utm_scenario: ERSTE_HAUSHALTE_SCENARIO,
    demo: demoVariantForAnswer(job),
    job,
  });
  return `/?${params.toString()}`;
}

/**
 * First guest-chat bubble after the question.
 * @param {{ answer?: string | null }} [opts]
 */
export function ersteHaushalteWelcomeText({ answer = "deadlines" } = {}) {
  const thanks =
    THANKS_BY_ANSWER[parseErsteHaushalteAnswer(answer)] || THANKS_BY_ANSWER.other;
  return `${thanks}\n\n${ERSTE_HAUSHALTE_VISION}`;
}

export function ersteHaushalteDemoText() {
  return `${ERSTE_HAUSHALTE_READY_TEXT}\n\n${ERSTE_HAUSHALTE_SETUP_HINT}`;
}

/** Chat CTA — Zurück returns to the matching guest thread. */
export function ersteHaushalteLoginHref({ answer } = {}) {
  return guestLoginHref(ERSTE_HAUSHALTE_SCENARIO, {
    back: ersteHaushalteChatPath({ answer }),
  });
}
